// getter/setter for EditReleaseTrackForm
import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

export interface EditReleaseTrackFormState {
  songTitle: string;
  artistName: string;
  featuredArtists: string;
  genre: string;
  secondaryGenre: string;
  language: string;
  parentalAdvisory: string;
}

export const initialState: EditReleaseTrackFormState = {
  songTitle: "",
  artistName: "",
  featuredArtists: "",
  genre: "",
  secondaryGenre: "",
  language: "41", // default to English (supply chain language option)
  parentalAdvisory: "",
};

export const editReleaseTrackFormStateAtom = atomWithReset(initialState);

export const editReleaseTrackFormAtom = atom(
  (get) => get(editReleaseTrackFormStateAtom),
  (get, set, updates: Partial<EditReleaseTrackFormState>) =>
    set(editReleaseTrackFormStateAtom, {
      ...get(editReleaseTrackFormStateAtom),
      ...updates,
    }),
);

export const isEditReleaseTrackFormValid = atom((get) => {
  const formState = get(editReleaseTrackFormStateAtom);
  return Boolean(
    formState.songTitle &&
      formState.artistName &&
      formState.genre &&
      formState.language &&
      formState.parentalAdvisory,
  );
});

editReleaseTrackFormAtom.debugLabel = "Edit Release Track Form Atom";
